import { api } from "../../utils/api";

export const postWhatsappDisconnect = async (connectionId) => {
  try {
    const response = await api.post(`/v2/whatsapp/disconnect/${connectionId}`);
    return response.data;
  } catch (error) {
    console.error("Erro ao desconectar WhatsApp:", error);
    throw error;
  }
};
